/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostLiffVideoMultiPartUploadSignedurlRequest
 */
export interface PostLiffVideoMultiPartUploadSignedurlRequest {
    /**
     * 
     * @type {string}
     * @memberof PostLiffVideoMultiPartUploadSignedurlRequest
     */
    fileName: string;
    /**
     * 
     * @type {number}
     * @memberof PostLiffVideoMultiPartUploadSignedurlRequest
     */
    fileSize: number;
}

/**
 * Check if a given object implements the PostLiffVideoMultiPartUploadSignedurlRequest interface.
 */
export function instanceOfPostLiffVideoMultiPartUploadSignedurlRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "fileSize" in value;

    return isInstance;
}

export function PostLiffVideoMultiPartUploadSignedurlRequestFromJSON(json: any): PostLiffVideoMultiPartUploadSignedurlRequest {
    return PostLiffVideoMultiPartUploadSignedurlRequestFromJSONTyped(json, false);
}

export function PostLiffVideoMultiPartUploadSignedurlRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostLiffVideoMultiPartUploadSignedurlRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': json['fileName'],
        'fileSize': json['fileSize'],
    };
}

export function PostLiffVideoMultiPartUploadSignedurlRequestToJSON(value?: PostLiffVideoMultiPartUploadSignedurlRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileName': value.fileName,
        'fileSize': value.fileSize,
    };
}

